// import { useState } from 'react';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { useTranslation } from 'react-i18next';
// import { Link, useNavigate } from 'react-router-dom';
// import { Card, CardBody } from '@components/card/card';

// import Button from 'react-bootstrap/Button';
// import ButtonGroup from 'react-bootstrap/ButtonGroup';
// import Dropdown from 'react-bootstrap/Dropdown';
// import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
// import NtxTable from '@components/DataTable/NtxTable';
// import Loading from '@components/Shared/Loader/Loading';
// import SuppliersForm from './SuppliersForm';
// import NeatixModal from '@components/Modal/NeatixModal';
// import { Can } from '@Permisstions/Can';

// const Index = () => {
//   const [showSupplierForm, setShowSupplierForm] = useState(false);
//   const [showSupplierForm2, setShowSupplierForm2] = useState(false);

//   const [id, setId] = useState<any>('');

//   const { t, i18n } = useTranslation();
//   const navigate = useNavigate();

//   const { SuppliersList, loading, error } = useGetSuppliersList();

//   const getPeopleTypeBadge = (type: string) => {
//     switch (type) {
//       case 'ESTABLISHMENT':
//         return (
//           <span
//             className='badge bg-primary bg-opacity-10 text-primary border border-primary border-opacity-25 d-flex align-items-center'
//             style={{ width: 'fit-content' }}
//           >
//             <i className='fas fa-building me-2'></i>
//             {t('مؤسسة')}
//           </span>
//         );
//       case 'COMPANY':
//         return (
//           <span
//             className='badge bg-info bg-opacity-10 text-info border border-info border-opacity-25 d-flex align-items-center '
//             style={{ width: 'fit-content' }}
//           >
//             <i className='fas fa-industry me-2'></i>
//             {t('شركة')}
//           </span>
//         );
//       case 'INDIVIDUAL':
//         return (
//           <span
//             className='badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 d-flex align-items-center'
//             style={{ width: 'fit-content' }}
//           >
//             <i className='fas fa-user me-2'></i>
//             {t('فردي')}
//           </span>
//         );
//       case 'GOVERNMENT':
//         return (
//           <span
//             className='badge bg-warning bg-opacity-10 text-warning border border-warning border-opacity-25 d-flex align-items-center'
//             style={{ width: 'fit-content' }}
//           >
//             <i className='fas fa-landmark me-2'></i>
//             {t('جهة حكومية')}
//           </span>
//         );
//       case 'EMPLOYEE':
//         return (
//           <span
//             className='badge bg-secondary bg-opacity-10 text-secondary border border-secondary border-opacity-25 d-flex align-items-center'
//             style={{ width: 'fit-content' }}
//           >
//             <i className='fas fa-id-badge me-2'></i>
//             {t('موظف')}
//           </span>
//         );
//       default:
//         return (
//           <span className='badge bg-light text-dark border d-flex align-items-center' style={{ width: 'fit-content' }}>
//             <i className='fas fa-question-circle me-2'></i>
//             {'غيـر معروف'}
//           </span>
//         );
//     }
//   };

//   const columns = [
//     { title: t('SupplierName'), key: 'name' },
//     { title: t('SupplierNumber'), key: 'num' },
//     { title: t('TradingName'), key: 'name2' },
//     { title: t('نوع المورد'), key: 'peopleType' },
//     { title: '', key: 'action', className: 'text-end' }
//   ];

//   const tableData =
//     SuppliersList?.filter(f => f.parentId === null)?.map(item => {
//       let rowClass;

//       return {
//         name: i18n.language === 'en' ? item.name : item.name2,
//         num: item.customerNumber,
//         name2: item.tradingName,
//         // peopleType: item.peopleType,
//         peopleType: getPeopleTypeBadge(item.peopleType),

//         action: (
//           <Dropdown as={ButtonGroup}>
//             <Can permission={'PURViewSuppliersDetails'}>
//               <Button
//                 className='btn-theme'
//                 onClick={() => {
//                   setId(item.id);
//                   setShowSupplierForm2(true);
//                 }}
//               >
//                 {t('SupplierDetails')}
//               </Button>
//             </Can>

//             <Dropdown.Toggle className=' btn-theme ms-1' split />
//           </Dropdown>
//         )
//       };
//     }) || [];

//   return (
//     <>
//       <div className='d-flex align-items-center'>
//         <Breadcrumb
//           BreadcrumbList={[
//             {
//               name: 'Home',
//               link: ':moduleHome'
//             },
//             {
//               name: t('Suppliers'),
//               link: null
//             }
//           ]}
//           PageName={t('Suppliers')}
//         />
//         <div className='ms-auto'>
//           <Can permission={['PURAddSuppliers']}>
//             <Link to={''} className='btn me-1 btn-outline-theme' onClick={() => setShowSupplierForm(true)}>
//               <i className='fa fa-plus-circle fa-fw me-1'></i>
//               {t('AddNewSupplier')}
//             </Link>
//           </Can>
//         </div>
//       </div>

//       <Card>
//         <Loading loading={loading} error={error}>
//           <CardBody>
//             <NtxTable
//               data={tableData || []}
//               columns={columns || []}
//               dataPerPage={10}
//               theadClass=''
//               tableClass='table text-nowrap table-hover '
//               enableSearch={true}
//               showRecordsSelector
//             />
//           </CardBody>
//         </Loading>
//       </Card>

//       <NeatixModal size='xl' show={showSupplierForm} showHeader={false} setShow={setShowSupplierForm}>
//         <SuppliersForm onClose={() => setShowSupplierForm(false)} />
//       </NeatixModal>

//       <NeatixModal size='xl' show={showSupplierForm2} showHeader={false} setShow={setShowSupplierForm2}>
//         {id && <SuppliersForm onClose={() => setShowSupplierForm2(false)} Id={id} isUpdate />}
//       </NeatixModal>
//     </>
//   );
// };

// export default Index;


import { useEffect, useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { Card, CardBody } from '@components/card/card';
import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
import Loading from '@components/Shared/Loader/Loading';
import SuppliersForm from './SuppliersForm';
import NeatixModal from '@components/Modal/NeatixModal';
import { Can } from '@Permisstions/Can';
import Pagination from '@components/Shared/Pagination/Pagination';

const Index = () => {
  const [showSupplierForm, setShowSupplierForm] = useState(false);
  const [showSupplierForm2, setShowSupplierForm2] = useState(false);
  const [showAddBranchForm, setShowAddBranchForm] = useState(false);
  const [selectedParentId, setSelectedParentId] = useState<string>('');
  const [selectedParentName, setSelectedParentName] = useState<string>('');

  const [id, setId] = useState<any>('');
  const [expandedRows, setExpandedRows] = useState<Set<string>>(new Set());
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [recordsPerPage, setRecordsPerPage] = useState<number>(10);

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const { SuppliersList, loading, error } = useGetSuppliersList();

  // دالة للحصول على الاسم المعروض بناءً على اللغة
  const getDisplayName = (item: any): string => {
    return i18n.language === 'en' ? item.name : item.name2;
  };

  // دالة لعرض نوع المورد
  const getPeopleTypeBadge = (type: string) => {
    switch (type) {
      case 'ESTABLISHMENT':
        return (
          <span
            className='badge bg-primary bg-opacity-10 text-primary border border-primary border-opacity-25'
            style={{ width: 'fit-content' }}
          >
            <i className='fas fa-building me-1'></i>
            {t('مؤسسة')}
          </span>
        );
      case 'COMPANY':
        return (
          <span
            className='badge bg-info bg-opacity-10 text-info border border-info border-opacity-25'
            style={{ width: 'fit-content' }}
          >
            <i className='fas fa-industry me-1'></i>
            {t('شركة')}
          </span>
        );
      case 'INDIVIDUAL':
        return (
          <span
            className='badge bg-success bg-opacity-10 text-success border border-success border-opacity-25'
            style={{ width: 'fit-content' }}
          >
            <i className='fas fa-user me-1'></i>
            {t('فردي')}
          </span>
        );
      case 'GOVERNMENT':
        return (
          <span
            className='badge bg-warning bg-opacity-10 text-warning border border-warning border-opacity-25'
            style={{ width: 'fit-content' }}
          >
            <i className='fas fa-landmark me-1'></i>
            {t('جهة حكومية')}
          </span>
        );
      case 'EMPLOYEE':
        return (
          <span
            className='badge bg-secondary bg-opacity-10 text-secondary border border-secondary border-opacity-25'
            style={{ width: 'fit-content' }}
          >
            <i className='fas fa-id-badge me-1'></i>
            {t('موظف')}
          </span>
        );
      default:
        return (
          <span className='badge bg-light text-dark border' style={{ width: 'fit-content' }}>
            <i className='fas fa-question-circle me-1'></i>
            {t('غير معروف')}
          </span>
        );
    }
  };

  // الحصول على الموردين الرئيسيين فقط مع البحث
  const mainSuppliers = SuppliersList?.filter((item: any) => {
    if (!item.parentId) {
      if (searchTerm.trim() === '') return true;

      const searchLower = searchTerm.toLowerCase();
      const name = getDisplayName(item).toLowerCase();
      const customerNumber = item.customerNumber?.toLowerCase() || '';
      const tradingName = item.tradingName?.toLowerCase() || '';
      const vatCode = item.vatCode?.toLowerCase() || '';

      return (
        name.includes(searchLower) ||
        customerNumber.includes(searchLower) ||
        tradingName.includes(searchLower) ||
        vatCode.includes(searchLower)
      );
    }
    return false;
  });

  // الحصول على الموردين الفرعيين لمورد رئيسي معين
  const getSubSuppliers = (parentId: string): any[] => {
    return SuppliersList?.filter((item: any) => item.parentId === parentId);
  };

  // تبديل حالة توسيع/طي الصف
  const toggleRow = (rowId: string): void => {
    const newExpandedRows = new Set(expandedRows);
    if (newExpandedRows.has(rowId)) {
      newExpandedRows.delete(rowId);
    } else {
      newExpandedRows.add(rowId);
    }
    setExpandedRows(newExpandedRows);
  };

  // فتح نموذج إضافة فرع
  const handleAddBranch = (parentId: string, parentName: string): void => {
    setSelectedParentId(parentId);
    setSelectedParentName(parentName);
    setShowAddBranchForm(true);
  };

  // دالة لعرض الموردين بشكل هرمي مع دعم الترقيم
  const renderSupplierRow = (item: any, level: number = 0, isChild: boolean = false): any => {
    const subSuppliers = getSubSuppliers(item.id);
    const hasChildren = subSuppliers && subSuppliers.length > 0;
    const isExpanded = expandedRows.has(item.id);

    return (
      <>
        {/* الصف الرئيسي */}
        <tr key={item.id} className={isChild ? 'table-active' : ''}>
          <td className='align-middle'>
            <div className='d-flex align-items-center'>
              <div style={{ marginRight: `${level * 25}px` }}></div>
              {hasChildren && (
                <button
                  type='button'
                  className='btn btn-sm btn-outline-secondary me-2'
                  onClick={() => toggleRow(item.id)}
                  style={{ width: '24px', height: '24px', padding: '0' }}
                >
                  <i className={`fas fa-${isExpanded ? 'minus' : 'plus'} fa-xs`}></i>
                </button>
              )}
              {!hasChildren && <span className='me-2' style={{ width: '24px' }}></span>}

              {/* <i className={`fas fa-${hasChildren ? 'building text-warning' : 'warehouse text-muted'} me-2`}></i> */}

              <div>
                <strong className={isChild ? 'text-muted' : ''}>{getDisplayName(item)}</strong>
              </div>
            </div>
          </td>
          <td className='align-middle'>
            <span className={`badge ${isChild ? 'bg-info' : 'bg-success'}`}>
              {item.customerNumber || '---'}
            </span>
          </td>
          <td className='align-middle'>
            <span className='text-muted'>{item.tradingName || '---'}</span>
          </td>
          <td className='align-middle'>
            {item.vatCode || '---'}
          </td>
          <td className='align-middle'>
            {getPeopleTypeBadge(item.peopleType)}
          </td>
          <td className='align-middle'>
            <div className='btn-group'>
              <Can permission={'PURViewSuppliersDetails'}>
                <button
                  type='button'
                  className='btn btn-sm btn-outline-theme me-1'
                  onClick={() => {
                    setId(item.id);
                    setShowSupplierForm2(true);
                  }}
                  title={t('SupplierDetails')}
                >
                  <i className='far fa-edit fa-fw me-1'></i>
                  {t('Edit')}
                </button>
              </Can>

              <button
                type='button'
                className='btn btn-sm btn-outline-info dropdown-toggle dropdown-toggle-split'
                data-bs-toggle='dropdown'
                aria-expanded='false'
              >
                <span className='visually-hidden'>Toggle Dropdown</span>
              </button>

              <ul className='dropdown-menu'>
                {/* خيار إضافة فرع للمورد */}
                <Can permission={'PURAddSuppliers'}>
                  <li>
                    <button
                      className='dropdown-item text-start'
                      onClick={() => handleAddBranch(item.id, getDisplayName(item))}
                    >
                      <i className='fas fa-plus-circle fa-lg me-2 text-theme'></i>
                      {t('إضافة فرع')}
                    </button>
                  </li>
                </Can>

                <li>
                  <button
                    className='dropdown-item text-start'
                    onClick={() =>
                      navigate(`${item.id}/PeopleLocations`, {
                        state: {
                          name: getDisplayName(item)
                        }
                      })
                    }
                  >
                    <i className='fas fa-map-marker-alt fa-lg me-2 text-theme'></i>
                    {t('Locations')}
                  </button>
                </li>
              </ul>
            </div>

            {hasChildren && (
              <button
                type='button'
                className='btn btn-sm btn-outline-secondary ms-1'
                onClick={() => toggleRow(item.id)}
                title={isExpanded ? t('Collapse') : t('Expand')}
              >
                <i className={`fas fa-${isExpanded ? 'compress' : 'expand'} fa-fw me-1`}></i>
                {isExpanded ? t('Collapse') : t('Expand')}
              </button>
            )}
          </td>
        </tr>

        {/* الموردين الفرعيين إذا كانت موسعة */}
        {hasChildren && isExpanded && subSuppliers.map((subItem: any) => 
          renderSupplierRow(subItem, level + 1, true)
        )}
      </>
    );
  };

  // حساب الإحصائيات مع التصفية حسب البحث
  const totalSuppliers: number = SuppliersList?.length || 0;
  const mainSuppliersCount: number = mainSuppliers?.length || 0;
  const subSuppliersCount: number = totalSuppliers - mainSuppliersCount;

  // تصنيف الموردين حسب النوع
  const establishmentSuppliers: number = SuppliersList?.filter((item: any) => 
    item.peopleType === 'ESTABLISHMENT'
  ).length || 0;

  const companySuppliers: number = SuppliersList?.filter((item: any) => 
    item.peopleType === 'COMPANY'
  ).length || 0;

  const individualSuppliers: number = SuppliersList?.filter((item: any) => 
    item.peopleType === 'INDIVIDUAL'
  ).length || 0;

  const governmentSuppliers: number = SuppliersList?.filter((item: any) => 
    item.peopleType === 'GOVERNMENT'
  ).length || 0;

  // حساب البيانات للترقيم
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = mainSuppliers?.slice(indexOfFirstRecord, indexOfLastRecord) || [];

  // عندما يتغير البحث، ارجع للصفحة الأولى
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  // إعادة تعيين التوسيع عند تغيير الصفحة
  useEffect(() => {
    setExpandedRows(new Set());
  }, [currentPage]);

  const breadcrumbList: any[] = [
    {
      name: 'Home',
      link: ':moduleHome'
    },
    {
      name: t('Suppliers'),
      link: null
    }
  ];

  // دالة مسح البحث
  const clearSearch = (): void => {
    setSearchTerm('');
  };

  return (
    <>
      <Loading loading={loading}>
        <div className='d-flex align-items-center'>
          <Breadcrumb BreadcrumbList={breadcrumbList} PageName={t('Suppliers')} />
          <div className='ms-auto'>
            <Can permission={['PURAddSuppliers']}>
              <Link to='' className='btn me-1 btn-theme' onClick={() => setShowSupplierForm(true)}>
                <i className='fa fa-plus-circle fa-fw me-1'></i>
                {t('AddNewSupplier')}
              </Link>
            </Can>
          </div>
        </div>

        {/* بطاقات الإحصائيات */}
        <div className='row mb-4'>
          {/* إجمالي الموردين */}
          <div className='col-md-3'>
            <Card className='bg-primary bg-opacity-10 border-primary border-0 shadow-sm h-100'>
              <CardBody className='py-3'>
                <div className='d-flex align-items-center'>
                  <div className='flex-shrink-0'>
                    <i className='fa fa-truck fa-2x text-primary'></i>
                  </div>
                  <div className='flex-grow-1 ms-3'>
                    <h4 className='text-primary mb-0'>{totalSuppliers}</h4>
                    <p className='text-muted mb-0'>إجمالي الموردين</p>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>

          {/* موردين مؤسسات */}
          <div className='col-md-2'>
            <Card className='bg-primary bg-opacity-10 border-primary border-0 shadow-sm h-100'>
              <CardBody className='py-3'>
                <div className='d-flex align-items-center'>
                  <div className='flex-shrink-0'>
                    <i className='fas fa-building fa-2x text-primary'></i>
                  </div>
                  <div className='flex-grow-1 ms-3'>
                    <h4 className='text-primary mb-0'>{establishmentSuppliers}</h4>
                    <p className='text-muted mb-0'>مؤسسات</p>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>

          {/* موردين شركات */}
          <div className='col-md-2'>
            <Card className='bg-info bg-opacity-10 border-info border-0 shadow-sm h-100'>
              <CardBody className='py-3'>
                <div className='d-flex align-items-center'>
                  <div className='flex-shrink-0'>
                    <i className='fas fa-industry fa-2x text-info'></i>
                  </div>
                  <div className='flex-grow-1 ms-3'>
                    <h4 className='text-info mb-0'>{companySuppliers}</h4>
                    <p className='text-muted mb-0'>شركات</p>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>

          {/* موردين أفراد */}
          <div className='col-md-2'>
            <Card className='bg-success bg-opacity-10 border-success border-0 shadow-sm h-100'>
              <CardBody className='py-3'>
                <div className='d-flex align-items-center'>
                  <div className='flex-shrink-0'>
                    <i className='fas fa-user fa-2x text-success'></i>
                  </div>
                  <div className='flex-grow-1 ms-3'>
                    <h4 className='text-success mb-0'>{individualSuppliers}</h4>
                    <p className='text-muted mb-0'>أفراد</p>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>

          {/* موردين جهات حكومية */}
          <div className='col-md-3'>
            <Card className='bg-warning bg-opacity-10 border-warning border-0 shadow-sm h-100'>
              <CardBody className='py-3'>
                <div className='d-flex align-items-center'>
                  <div className='flex-shrink-0'>
                    <i className='fas fa-landmark fa-2x text-warning'></i>
                  </div>
                  <div className='flex-grow-1 ms-3'>
                    <h4 className='text-warning mb-0'>{governmentSuppliers}</h4>
                    <p className='text-muted mb-0'>جهات حكومية</p>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>

        <Card className='mb-4'>
          <div className='card-header d-flex justify-content-between align-items-center'>
            <h6 className='mb-0'>
              <i className='fas fa-truck me-2'></i>
              سجل الموردين
            </h6>

            <div className='d-flex align-items-center'>
              {/* عدد السجلات في الصفحة */}
              <div className='me-3'>
                <select
                  className='form-select form-select-sm'
                  style={{ width: '80px' }}
                  value={recordsPerPage}
                  onChange={e => {
                    setRecordsPerPage(Number(e.target.value));
                    setCurrentPage(1);
                  }}
                >
                  <option value='5'>5</option>
                  <option value='10'>10</option>
                  <option value='20'>20</option>
                  <option value='50'>50</option>
                  <option value='100'>100</option>
                </select>
              </div>

              {/* شريط البحث */}
              <div className='input-group input-group-sm' style={{ width: '300px' }}>
                <span className='input-group-text'>
                  <i className='fas fa-search text-muted'></i>
                </span>
                <input
                  type='text'
                  className='form-control border-start-0'
                  placeholder='ابحث باسم المورد أو الرقم أو الاسم التجاري...'
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                />
                {searchTerm && (
                  <button className='btn btn-outline-secondary' type='button' onClick={clearSearch} title='مسح البحث'>
                    <i className='fas fa-times'></i>
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className='card-body p-0'>
            <div className='table-responsive'>
              <table className='table table-hover mb-0'>
                <thead className='bg-theme bg-opacity-25 fw-bold'>
                  <tr>
                    <th className=''>اسم المورد</th>
                    <th className=''>رقم المورد</th>
                    <th className=''>الاسم التجاري</th>
                    <th className=''>الرقم الضريبي</th>
                    <th className=''>نوع المورد</th>
                    <th className=''>الإجراءات</th>
                  </tr>
                </thead>
                <tbody>
                  {currentRecords?.length > 0 ? (
                    currentRecords.map((item: any) => renderSupplierRow(item))
                  ) : (
                    <tr>
                      <td colSpan={6} className='text-center py-4 text-muted'>
                        <i className='fa fa-truck fa-2x mb-2'></i>
                        <br />
                        {searchTerm ? 'لا توجد نتائج للبحث' : 'لا توجد موردين مسجلين'}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className='card-footer'>
            {mainSuppliers?.length > 0 && (
              <Pagination
                filteredData={mainSuppliers}
                dataPerPage={recordsPerPage}
                handlePagination={setCurrentPage}
                currentPage={currentPage}
              />
            )}
          </div>
        </Card>
      </Loading>

      {/* Modal لإضافة فرع جديد */}
      <NeatixModal size='xl' show={showAddBranchForm} showHeader={false} setShow={setShowAddBranchForm}>
        <SuppliersForm
          onClose={() => {
            setShowAddBranchForm(false);
            setSelectedParentId('');
            setSelectedParentName('');
          }}
          parentId={selectedParentId}
          parentName={selectedParentName}
        />
      </NeatixModal>

      <NeatixModal size='xl' show={showSupplierForm} showHeader={false} setShow={setShowSupplierForm}>
        <SuppliersForm onClose={() => setShowSupplierForm(false)} />
      </NeatixModal>

      <NeatixModal size='xl' show={showSupplierForm2} showHeader={false} setShow={setShowSupplierForm2}>
        {id && <SuppliersForm onClose={() => setShowSupplierForm2(false)} Id={id} isUpdate />}
      </NeatixModal>
    </>
  );
};

export default Index;